import { PredictVulnerabilityResponse } from "../model/PredictResponseModel";
import FileContainer from "../components/FileContainer";
import { useState } from "react";
import LLMRecommendation from "../components/LLMRecommendation";

function ReportPage(props: {
  listFileVulnerability: PredictVulnerabilityResponse[];
  setListFileVulnerability: any;
}) {
  const [openModel, setOpenModel] = useState(false);
  const [selectedFile, setSelectedFile] = useState<string | null>(null);

  const handleSubmitBack = () => {
    props.setListFileVulnerability([]);
  };

  return (
    <div className="min-h-screen  px-8 py-10">
      <div className="w-full max-w-6xl mx-auto">
        <button
          onClick={handleSubmitBack}
          className="px-6 py-2 bg-green-500 text-lg text-black font-mono font-bold rounded hover:bg-green-400 transition-colors uppercase mb-10"
        >
          &lt; Back
        </button>

        <div className="flex flex-col items-center">
          <div className="text-3xl font-bold text-center mb-10 text-green-400 font-mono tracking-wider">
            [ File Vulnerability Breakdown ]
          </div>

          <ul className="w-full space-y-4">
            {props.listFileVulnerability
              .slice()
              .sort(
                (a, b) =>
                  Number(b.predictionProbability) -
                  Number(a.predictionProbability)
              )
              .map((file, index) => (
                <li key={index}>
                  <FileContainer
                    fileData={file}
                    setOpenModel={setOpenModel}
                    selectedFile={selectedFile}
                    setSelectedFile={setSelectedFile}
                  />
                </li>
              ))}
          </ul>
        </div>

        {openModel && (
          <LLMRecommendation
            selectedFile={selectedFile}
            listFileVulnerability={props.listFileVulnerability}
            isOpen={openModel}
            onClose={() => setOpenModel(false)}
          />
        )}
      </div>
    </div>
  );
}

export default ReportPage;